import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { common } from '@ocean/ui'
import trainingLibraryRoutes from 'modules/trainingLibrary/TrainingLibrary/routing/routes'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const ElearningCategory = lazy(
  () =>
    import(
      /* webpackChunkName: "TrainingLibraryElearningCategory" */ 'modules/trainingLibrary/Elearning/pages/ElearningCategory'
    )
)

const ElearningRouting = () => (
  <Suspense fallback={<RouteChangeProgress />}>
    <Switch>
      <Route exact path={`${routes.category}/:categoryId`} component={ElearningCategory} />
      <Redirect path='*' to={trainingLibraryRoutes.root} />
    </Switch>
  </Suspense>
)

export default ElearningRouting
